import { jsx as _jsx } from "react/jsx-runtime";
import { Card as AntCard } from 'antd';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
export const Card = ({ children, size = 'medium', variant = 'default', hoverable = true, className = '', ...props }) => {
    const variantClass = `legarta-card--${variant}`;
    const sizeClass = `legarta-card--${size}`;
    return (_jsx(StyledCard, { hoverable: hoverable, className: `legarta-card ${variantClass} ${sizeClass} ${className}`, ...props, children: children }));
};
const StyledCard = styled(AntCard) `
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: none;

  &.legarta-card--default {
    background: ${colors.backgroundPrimary};
    box-shadow: 0 2px 8px ${colors.shadowLight};
  }

  &.legarta-card--elevated {
    background: ${colors.backgroundPrimary};
    box-shadow: 0 8px 24px ${colors.shadowMedium};
  }

  &.legarta-card--outlined {
    background: ${colors.backgroundPrimary};
    border: 1px solid ${colors.borderLight};
    box-shadow: none;
  }

  &.legarta-card--small {
    padding: 16px;
  }

  &.legarta-card--medium {
    padding: 24px;
  }

  &.legarta-card--large {
    padding: 32px;
  }

  &:hover {
    transform: translateY(-4px);
  }

  &.legarta-card--default:hover {
    box-shadow: 0 4px 16px ${colors.shadowMedium};
  }

  &.legarta-card--elevated:hover {
    box-shadow: 0 12px 32px ${colors.shadowDark};
  }

  &.legarta-card--outlined:hover {
    border-color: ${colors.primary};
    box-shadow: 0 2px 8px rgba(227, 30, 36, 0.1);
  }

  .ant-card-body {
    padding: 0;
  }

  .ant-card-head {
    border-bottom: 1px solid ${colors.borderLight};
    padding: 0 24px;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: ${colors.textPrimary};
  }
`;
